import { Plus } from 'lucide-react';
import { UDButton, UDText } from 'ud-ui/components';

export interface StageGroupEmptyProps {
  onAddClick?: () => void;
}

const StageGroupEmpty = (props: StageGroupEmptyProps) => {
  return (
    <div className={'bordered-block flex-center h-60 flex-col gap-5'}>
      <UDText variant={'body-3'}>Список групп пуст. Создайте группы задав название</UDText>
      <UDButton variant={'primary'} onClick={props.onAddClick}>
        <Plus size={20} className="mr-2" />
        Создать
      </UDButton>
    </div>
  );
};

export default StageGroupEmpty;
